import {put, takeLatest} from 'redux-saga/effects';
import {getSuccessManagerApi} from 'helpers/services/api/locationSettings';
import {GET_SUCCESS_MANAGER, GET_SUCCESS_MANAGER_SUCCESS} from './action';

// A failed load stores nothing, so the next mount of either placement retries.
export function* getSuccessManager({payload: locationId}) {
  try {
    const response = yield getSuccessManagerApi(locationId);
    // Offline, request() resolves with no response instead of throwing.
    if (!response) return;

    yield put(
      GET_SUCCESS_MANAGER_SUCCESS({
        locationId,
        manager: response.data?.data || null
      })
    );
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}

function* successManagerSaga() {
  yield takeLatest(GET_SUCCESS_MANAGER, getSuccessManager);
}

export default successManagerSaga;
